// removed by extract-text-webpack-plugin
module.exports = {"richEditor":"g42RfwVHlanTFcoo8AAig"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RichEditor/RichEditor.scss
// module id = 972
// module chunks = 0